import Root from './Root'
import rootContainer from './rootContainer'

export default rootContainer(Root)
